import { TextLeftIcon, TextMiddleIcon, TextRightIcon } from 'canoe';
import React from 'react';

import { ValueBox, ValueBoxGroupOptions, ValueToggle } from '@candu-ai/craft/ui';
import { StylesHierarchy } from 'craft/hooks';
import { createToggle } from 'craft/utils';

interface Props {
  cssProps: Record<string, unknown>;
  setCss: (e: Record<string, unknown>) => void;
  stylesHierarchy: StylesHierarchy;
  isInGroup?: ValueBoxGroupOptions;
}

export const TextAlignment = ({ cssProps, setCss, isInGroup, stylesHierarchy }: Props) => {
  const { textAlign } = cssProps;

  const toggleValues = createToggle(cssProps, setCss);

  const defaultValue = stylesHierarchy?.textAlign?.fallbackValue || 'left';

  return (
    <ValueBox label="Alignment" isInGroup={isInGroup}>
      <ValueToggle
        data-cy="text-align-left"
        toggleGroup="text-align"
        onClick={() => toggleValues({ textAlign: 'left' })}
        isActive={textAlign === 'left' || (!textAlign && defaultValue === 'left')}
        icon={TextLeftIcon}
        tooltip="Left"
        color="light"
      />
      <ValueToggle
        data-cy="text-align-center"
        toggleGroup="text-align"
        onClick={() => toggleValues({ textAlign: 'center' })}
        isActive={textAlign === 'center' || (!textAlign && defaultValue === 'center')}
        icon={TextMiddleIcon}
        tooltip="Center"
        color="light"
      />
      <ValueToggle
        data-cy="text-align-right"
        toggleGroup="text-align"
        onClick={() => toggleValues({ textAlign: 'right' })}
        isActive={textAlign === 'right' || (!textAlign && defaultValue === 'right')}
        icon={TextRightIcon}
        tooltip="Right"
        color="light"
      />
    </ValueBox>
  );
};
